import { useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import colors from "assets/theme/base/colors";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ContactInline from "components/ContactForm/ContactForm";
import IndexPageHeader from './Components/IndexHeader';
import IndexStats from './Components/IndexStats';
import HowItWorks from './Components/HowItWorks';
import WhatCanWeDetect from './Components/WhatCanWeDetect';
import StatItemOne from './Components/StatItemOne';
import StatItemTwo from './Components/StatItemTwo';
import RemoveHumans from './Components/RemoveHumans';
import CustomerSuccessStories from './Components/CustomerSuccessStories';
import PricingTable from './Components/Pricing';

const defaultTheme = createTheme({
    palette: { ...colors },
    typography: {
        button: { textTransform: 'none' },
    },
});

export default function Index() {
    useEffect(() => {}, []);

    return (
        <ThemeProvider theme={defaultTheme}>

            {/* ─── HERO ─── */}
            <Grid container id="home">
                <IndexPageHeader />
            </Grid>

            {/* ─── THREAT STATS ─── */}
            <IndexStats />

            {/* ─── HOW IT WORKS + PLATFORM SCREENSHOTS ─── */}
            <HowItWorks />

            {/* ─── CAPABILITIES ─── */}
            <WhatCanWeDetect />

            {/* ─── CALLOUT: 94% ─── */}
            <StatItemOne />

            {/* ─── AI vs HUMAN COMPARISON ─── */}
            <RemoveHumans />

            {/* ─── TESTIMONIALS ─── */}
            <CustomerSuccessStories />

            {/* ─── CALLOUT: 82% CLOUD ─── */}
            <StatItemTwo />

            {/* ─── PRICING ─── */}
            <PricingTable />

            {/* ─── CONTACT ─── */}
            <Box
                sx={{
                    background: '#f8f9fa',
                    display: 'grid',
                    placeItems: 'center',
                }}
            >
                <Grid container maxWidth="lg" spacing={2} justifyContent="center" sx={{ px: 2 }} >
                    <ContactInline />
                </Grid>
            </Box>

        </ThemeProvider>
    );
}
